var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerchant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.125 11.375V8.66667C8.125 8.52301 8.06793 8.38523 7.96635 8.28365C7.86477 8.18207 7.72699 8.125 7.58333 8.125H5.41667C5.27301 8.125 5.13523 8.18207 5.03365 8.28365C4.93207 8.38523 4.875 8.52301 4.875 8.66667V11.375",
    stroke: "#0E3A4C",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.62758 5.58458C9.51467 5.47649 9.36438 5.41615 9.20806 5.41615C9.05174 5.41615 8.90146 5.47649 8.78854 5.58458C8.53667 5.82482 8.20197 5.95885 7.8539 5.95885C7.50583 5.95885 7.17112 5.82482 6.91925 5.58458C6.80636 5.47665 6.65619 5.41641 6.5 5.41641C6.34381 5.41641 6.19364 5.47665 6.08075 5.58458C5.82885 5.82498 5.49403 5.95911 5.14583 5.95911C4.79763 5.95911 4.46281 5.82498 4.21092 5.58458C4.098 5.47649 3.94771 5.41615 3.7914 5.41615C3.63508 5.41615 3.48479 5.47649 3.37187 5.58458C3.12858 5.81675 2.80761 5.95008 2.47142 5.95863C2.13524 5.96718 1.8079 5.85033 1.55312 5.63083C1.29835 5.41133 1.13436 5.10488 1.09307 4.77113C1.05179 4.43738 1.13617 4.10021 1.32979 3.82525L2.89467 1.55892C2.99396 1.4124 3.12763 1.29245 3.284 1.20954C3.44038 1.12663 3.61468 1.0833 3.79167 1.08333H9.20833C9.38481 1.08327 9.55862 1.12631 9.71467 1.20872C9.87071 1.29114 10.0043 1.41042 10.1037 1.55621L11.6718 3.82687C11.8655 4.10206 11.9498 4.43948 11.9082 4.7734C11.8667 5.10733 11.7023 5.41382 11.4471 5.63317C11.192 5.85251 10.8642 5.96899 10.5279 5.95991C10.1915 5.95083 9.87056 5.81684 9.62758 5.58404",
    stroke: "#0E3A4C",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.16667 5.93125V10.2917C2.16667 10.579 2.2808 10.8545 2.48397 11.0577C2.68713 11.2609 2.96268 11.375 3.25 11.375H9.75C10.0373 11.375 10.3129 11.2609 10.516 11.0577C10.7192 10.8545 10.8333 10.579 10.8333 10.2917V5.93125",
    stroke: "#0E3A4C",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchant);
export default __webpack_public_path__ + "static/media/merchant.1af70354940c12a30de0e2f5a9f046dc.svg";
export { ForwardRef as ReactComponent };